import { fetchWithAuth } from './config';

const getPermissions = async () => {
  const permissions = await fetchWithAuth('/permissions');

  return permissions;
};

const createPermission = async ({ name, serviceId }: { name: string, serviceId: string }) => {
  await fetchWithAuth('/permissions', {
    method: 'POST',
    body: JSON.stringify({ name, serviceId }),
  });
};

const deletePermission = async (permissionId: string) => {
  await fetchWithAuth(`/permissions/${permissionId}`, {
    method: 'DELETE',
  });
};

const addPermissionToUser = async (userId: string, permissionId: string) => {
  await fetchWithAuth(`/permissions/${permissionId}/users`, {
    method: 'POST',
    body: JSON.stringify({ userId }),
  });
};

const removePermissionFromUser = async (userId: string, permissionId: string) => {
  await fetchWithAuth(`/permissions/${permissionId}/users/${userId}`, {
    method: 'DELETE',
  });
};

const getPermissionsForUser = async (userId: string) => {
  const userPermissions = await fetchWithAuth(`/permissions/user/${userId}`);

  return userPermissions;
};

export {
  getPermissions,
  createPermission,
  deletePermission,
  addPermissionToUser,
  removePermissionFromUser,
  getPermissionsForUser,
};
